module.exports = __webpack_public_path__ + "media/images/points_4-aec0bf0f5fe7a73f0a71b55585ae76b0.svg";